export default "__VITE_ASSET__gVLFywTe__"